const filterNameMapping = {
  dealType: 'price-rating',
  doorCode: 'doors',
  driveGroup: 'drive-type',
  endYear: 'year-max',
  engineCode: 'cylinders',
  extColorSimple: 'exterior-color',
  fuelTypeGroup: 'fuel-type',
  homeServices: 'dealer-home-services',
  intColorSimple: 'interior-color',
  listingType: 'condition',
  makeCode: 'make',
  maxPrice: 'price-max',
  mileage: 'mileage',
  minPrice: 'price-min',
  modelCode: 'model',
  mpgRange: 'fuel-economy',
  sellerType: 'seller-type',
  seriesCode: 'series',
  startYear: 'year-min',
  transmissionCode: 'transmission',
  trimCode: 'trim',
  vehicleHistoryType: 'vehicle-history',
  vehicleStyleCode: 'body-style',
  marketExtension: 'cta'
};
const pixallFilterNameTransformer = filterName => filterNameMapping[filterName] || filterName;
export default pixallFilterNameTransformer;